module.exports = __webpack_public_path__ + "static/media/forward-icon.bf382e05.svg";